import { render, staticRenderFns } from "./Theme1TheFooter.vue?vue&type=template&id=242848ac&scoped=true&"
import script from "./Theme1TheFooter.vue?vue&type=script&lang=js&"
export * from "./Theme1TheFooter.vue?vue&type=script&lang=js&"
import style0 from "./Theme1TheFooter.vue?vue&type=style&index=0&id=242848ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242848ac",
  null
  
)

export default component.exports